import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddFreeVideoLayer from "../components/AddFreeVideoLayer";
 
 
const AddFreeVideoPage = () => {
  return (
    <>
     
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Free Video  </h5><Breadcrumb title="Add Free Video" /></div>
 
        {/* CalendarMainLayer */}
        <AddFreeVideoLayer />

    </>
  );
};
 
export default AddFreeVideoPage;
 
 